<template>
   <div class="share-container container container-1200 mt-3 mb-3">
      <div class="h3">Share with your colleagues</div>
      <div class="icon-container">
         <i id="panelACopyBtn" class="fc_envelop icons" @click="mailTo" />
         <b-tooltip target="panelACopyBtn" placement="bottom">Share By Email</b-tooltip>
         <i id="panelBCopyBtn" class="fc_link icons" />
         <b-tooltip target="panelBCopyBtn" placement="bottom">{{ tooltipText }}</b-tooltip>
      </div>
   </div>
</template>

<script>

export default {
   name: 'ShareOptions',
   props: {
      subject: {
         type: String,
         default: 'Mail Subject',
      },
      body: {
         type: String,
         default: 'Mail Body',
      },
   },
   data() {
      return {
         Clipboard: null,
         tooltipTextOptions: {
            normal: 'Copy To Clipboard',
            success: 'Copied!',
         },
         tooltipText: 'Copy To Clipboard',
      };
   },
   async mounted() {
      const currentUrl = this.$router.history.current.path;

      this.Clipboard = (await import('clipboard')).default;
      const panelBClip = new this.Clipboard('#panelBCopyBtn', {
         text: () => `https://www.fusioncharts.com${currentUrl}`,
      });
      panelBClip.on('success', () => {
         this.tooltipText = this.tooltipTextOptions.success;

         setTimeout(() => {
            this.tooltipText = this.tooltipTextOptions.normal;
         }, 3000);
      });
   },
   methods: {
      mailTo() {
         window.location.href = `mailto:user@example.com?subject=${this.subject}&body=${this.body}`;
      },
   },
};
</script>

<style lang="scss">
.share-container {
   margin-bottom: 80px;
   h3 {
      padding-bottom: 18px;
      color: #212344;
      font-size: 18px;
      font-weight: 600;
      line-height: 23px;
   }

   .icon-container {
      display: flex;
      align-items: center;

      .icons {
         opacity: 1;
         box-shadow: 0 0 7px 0 rgba(74, 74, 74, 0.08);
         border: 1px solid rgba(74, 74, 74, 0.05);
         border-radius: 50%;
         margin-right: 13px;
         height: 45px;
         width: 45px;
         color: #a4a4a4;
         text-align: center;
         line-height: 44px;
         cursor: pointer;
         transition: all ease 0.35s;

         &:hover {
            box-shadow: 0 0 9px #ced4da;
            color: #2cc7c0;
         }
      }
   }
}
</style>
